/**
 * Helper functions for analytics
 */

/**
 * Check if element is in viewport
 */

let observer

const impression = (elementList, handler) => {
  observer = observer || new IntersectionObserver(handler, { threshold: 0.5 })
  elementList.forEach(element => {
    observer.observe(element)
  })
}

export default impression
